<template>
  <div>
    <v-row>
      <v-col cols="9">
        <v-card class="d-flex align-content-space-around flex-wrap" flat id="qrcodes">
          <PrintLocationCard
            v-for="(location, index) in locations"
            :key="location.id"
            class="doNotCut"
            :location="location"
            :logo="logo"
            :index="index"
            :showName="showName"
            :header="header"
            :subtitle="subtitle"
            :size="size"
            :selectQrsToPrint="selectQrsToPrint"
          />
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-form style="position:fixed">
          <v-text-field v-model="header" :label="$t('Header')" />
          <v-text-field v-model="subtitle" :label="$t('Subtitle')" />

          <v-switch v-model="showName" :label="$t('Show location name')" />
          <v-switch v-model="selectQrsToPrint" :label="$t('Print only selected QRs')" />

          <v-slider v-model="size" min="60" max="400" :label="$t('Qr size')"></v-slider>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PrintLocationCard from "@/views/dashboard/components/locations/PrintLocationCard";

export default {
  data() {
    return {
      selectQrsToPrint: false,
      showName: true,
      header: "",
      subtitle: "",
      size: 200,
      logo: this.$store.getters.restaurant.logo
    };
  },
  components: { PrintLocationCard },

  computed: {
    locations() {
      return this.$store.getters.locations;
    }
  }
};
</script>

<style>
@media print {
  @page {
    margin: 20mm;
  }

  body * {
    visibility: hidden;
    display: contents;
  }

  #qrcodes,
  #qrcodes * {
    display: grid;
    visibility: visible;
  }
  #qrcodes {
    position: fixed;
    left: 10px;
    top: 10px;
  }
  .qrcode {
    border-radius: 20px;
  }
  .doNotCut * {
    page-break-inside: avoid;
  }
  .hiddenAtPrint {
    visibility: hidden;
  }
}
</style>
